"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _texts = require("../../atomic/texts");
var Details = function Details(_ref) {
  var details = _ref.details;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "details__list"
  }, details.map(function (detail) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: JSON.stringify(detail),
      className: "details__item"
    }, !!detail.icon && /*#__PURE__*/_react.default.createElement("span", {
      className: detail.icon
    }, /*#__PURE__*/_react.default.createElement("svg", {
      width: "15",
      height: "12",
      viewBox: "0 0 15 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M0.726562 5.63636L4.98692 9.99999L13.4869 1.5",
      stroke: "white",
      strokeWidth: "2"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "details__text-wrap"
    }, detail === null || detail === void 0 ? void 0 : detail.text.map(function (p, jdx) {
      if (jdx === 0) {
        return /*#__PURE__*/_react.default.createElement(_texts.Text, {
          key: "".concat(p),
          as: "p",
          className: "details__text-wrap--first-line"
        }, /*#__PURE__*/_react.default.createElement("strong", null, detail === null || detail === void 0 ? void 0 : detail.title), " ", p);
      }
      return /*#__PURE__*/_react.default.createElement(_texts.Text, {
        as: "p",
        className: "details__text-wrap--description",
        key: "".concat(p)
      }, p);
    })));
  }));
};
Details.propTypes = {
  details: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    icon: _propTypes.default.string,
    text: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
  }))
};
Details.defaultProps = {
  details: [{
    title: 'Sample highlitled text,',
    icon: 'checkmark-income',
    text: ['text', 'multiple', 'parragraphs']
  }]
};
var _default = Details;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');